<template>
  <ui-nav-menu>
    <router-link
      v-for="link in menuItems"
      :to="link.destination"
      :key="link.destination"
      :rel="link.rel"
      @click.native="setManualHistory([])"
    >
      {{ link.label }}
    </router-link>
  </ui-nav-menu>
</template>

<script>
import { shopifySections } from '@/router/paths';
import { mapMutations } from 'vuex';

export default {
  name: 'ShopifyMenu',
  computed: {
    menuItems() {
      const polarisMenu = shopifySections.map(el => ({
        label: this.$t('Drawer.' + el.name),
        destination: el.path.replace(/:[\w\-_\\()+]+\??\/?/g, '').replace(/\/$/, ''),
      }));

      return [{ label: 'Home', rel: 'home', destination: '/overview' }].concat(polarisMenu);
    },
  },
  methods: {
    ...mapMutations('app', ['setManualHistory']),
  },
};
</script>

<style scoped lang="scss"></style>
